export default "/images/7a637e4a01a3681e0e3ca475a2a5bbfc.avif";